import { useState, useEffect, useRef } from 'react';

export const useAudio = (url) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (typeof url === 'string') {
      // eslint-disable-next-line no-undef
      audioRef.current = new Audio(url);

      const handlePlay = () => setIsPlaying(true);
      const handlePause = () => setIsPlaying(false);

      audioRef.current.addEventListener('play', handlePlay);
      audioRef.current.addEventListener('pause', handlePause);

      return () => {
        audioRef.current?.removeEventListener('play', handlePlay);
        audioRef.current?.removeEventListener('pause', handlePause);
      };
    } else {
      console.error('Invalid URL:', url);
    }
  }, [url]);

  const play = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.error('Error playing audio:', error);
      });
    }
  };

  const pause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  return {
    isPlaying,
    play,
    pause,
  };
};
